var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008659(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.1152,
    y: 16.5859,
    width: 13.764,
    height: 26.4693,
    fill: "#F7B53C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3535 15.7242L10.3759 15.6992",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6426 15.7242L19.665 15.6992",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3535 25.0171L10.3759 24.9922",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6426 25.0171L19.665 24.9922",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3535 34.314L10.3759 34.2891",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6426 34.314L19.665 34.2891",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9376 43.5832H1.61426C1.3063 43.5832 1.05664 43.3335 1.05664 43.0255V6.96617C1.05664 6.65817 1.3063 6.40855 1.61426 6.40855H14.9971V2.31934C14.9971 2.01137 15.2467 1.76172 15.5547 1.76172H28.38C28.688 1.76172 28.9376 2.01137 28.9376 2.31934V15.7022M28.9376 43.5832H42.3205C42.6285 43.5832 42.8781 43.3335 42.8781 43.0255V16.2598C42.8781 15.9518 42.6285 15.7022 42.3205 15.7022H28.9376M28.9376 43.5832V34.2895M28.9376 15.7022V24.9959M28.9376 34.2895V24.9959M28.9376 34.2895H33.5844M28.9376 24.9959H33.5844",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008659);
export default __webpack_public_path__ + "static/media/Group 1000008659.98eb30d63c66961f17f11368a663199c.svg";
export { ForwardRef as ReactComponent };